document.addEventListener('DOMContentLoaded', () => {
    Mix.init();
});

const Mix = {
    init: function () {
        setTimeout(() => {
            // this.productCollectionPillsHeight();
            this.productCollectionTitleHeight();
        }, 400);
        window.addEventListener('scroll', this.toggleActiveClass);
        if (window.innerWidth > 767) {
            // const fadeSection = document.querySelector('.fade-section');
            // if(fadeSection) {
            //     window.addEventListener('scroll', this.handleScroll);
            // }
            const productInfo = document.querySelector('.product-info__holder');
            if(productInfo) {
                window.addEventListener('scroll', this.productInfoScrollImage);
            }
        }
        if(window.innerWidth < 768) {
            this.accordionOnMobile();
        }
        const elements = document.querySelectorAll('.text-image__box-title');
        elements.forEach(element => {
            element.textContent = element.textContent
            .toLowerCase()
            .replace(/\b\w/g, char => char.toUpperCase());
        });
    },

    productCollectionPillsHeight: function () {
        const cards = document.querySelectorAll('.card__pills');
        let maxHeight = 0;
        cards.forEach(card => {
            let cardHeight = card.offsetHeight;
            if (cardHeight > maxHeight) {
                maxHeight = cardHeight;
            }
        });
        cards.forEach(card => {
            card.style.height = `${maxHeight}px`;
        });
    },

    productCollectionTitleHeight: function () {
        const cards = document.querySelectorAll('.card__title');
        let maxHeight = 0;
        cards.forEach(card => {
            let cardHeight = card.offsetHeight;
            if (cardHeight > maxHeight) {
                maxHeight = cardHeight;
            }
        });
        cards.forEach(card => {
            card.style.height = `${maxHeight}px`;
        });
    },

    benefitsSideImagesAppend: function() {
        const fadeSectionHolder = document.querySelector('.fade-section__holder');
        const fadeSectionLeftSide = document.querySelector('.fade-section__left-side');
        const fadeSectionLeft = document.querySelector('.fade-section__left');

        if (window.innerWidth < 768) {
            fadeSectionHolder.appendChild(fadeSectionLeftSide);
        } else {
            fadeSectionLeft.insertBefore(fadeSectionLeftSide, fadeSectionLeft.firstChild);
        }
    },

    toggleActiveClass: function () {
        const boxes = document.querySelectorAll('.js-active-class-box');
        const activationOffset = 450;

        boxes.forEach(box => {
            const rect = box.getBoundingClientRect();
            const isActive = rect.top <= activationOffset && rect.bottom >= 0;

            if (isActive) {
                box.classList.add('is-active');
            } else {
                box.classList.remove('is-active');
            }
        });
    },

    handleScroll:function () {
        const leftSection = document.querySelector('.fade-section__left');
        const holder = document.querySelector('.fade-section__holder');
        const fadeSection = document.querySelector('.fade-section');
        const offsetTop = 20;
        const holderBottom = holder.getBoundingClientRect().bottom + window.pageYOffset;
        const leftSectionHeight = leftSection.offsetHeight;
        const fadeSectionTop = fadeSection.getBoundingClientRect().top + window.pageYOffset;

        if (window.pageYOffset + offsetTop >= fadeSectionTop) {
            leftSection.style.position = 'sticky';
            leftSection.style.top = `${offsetTop}px`;

            if (window.pageYOffset + leftSectionHeight + offsetTop > holderBottom) {
                leftSection.style.position = 'absolute';
                leftSection.style.top = 'auto';
                leftSection.style.bottom = '0';
            }
        } else {
            leftSection.style.position = 'static';
        }
    },

    productInfoScrollImage:function () {
        const leftSection = document.querySelector('.product-info__right');
        const holder = document.querySelector('.product-info__holder');
        const fadeSection = document.querySelector('.product-info');
        const offsetTop = 90;
        const holderBottom = holder.getBoundingClientRect().bottom + window.pageYOffset;
        const leftSectionHeight = leftSection.offsetHeight;
        const fadeSectionTop = fadeSection.getBoundingClientRect().top + window.pageYOffset;

        if (window.pageYOffset + offsetTop >= fadeSectionTop) {
            leftSection.style.position = 'sticky';
            leftSection.style.top = `${offsetTop}px`;

            if (window.pageYOffset + leftSectionHeight + offsetTop > holderBottom) {
                leftSection.style.position = 'absolute';
                leftSection.style.top = 'auto';
                leftSection.style.bottom = '0';
            }
        } else {
            leftSection.style.position = 'static';
        }
    },

    accordionOnMobile: function () {
        const boxes = document.querySelectorAll('.product-info__left-box');

        boxes.forEach(box => {
            const title = box.querySelector('.product-info__left-box-title');
            const content = box.querySelector('.product-info__left-box-info, .product-info__left-box-table-wrap, .product-info__left-box-desc');
            if (box.classList.contains('is-opened')) {
                content.style.maxHeight = content.scrollHeight + 'px';
            }

            title.addEventListener('click', function() {
                if (box.classList.contains('is-opened')) {
                    content.style.maxHeight = 0;
                    box.classList.remove('is-opened');
                } else {
                    content.style.maxHeight = content.scrollHeight + 'px';
                    box.classList.add('is-opened');
                }
            });
        });
    },
};